module.exports = __webpack_public_path__ + "img/mission_info_grid_no_claim.7900725e.png";